import SvgIcon from "@mui/material/SvgIcon";

export default function ArrowDownIcon(props: any) {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32">
      <path d="m16 21.4-9.1-9.1 1.13-1.13L16 19.14l7.97-7.97 1.13 1.13-9.1 9.1" />
    </SvgIcon>
  );
}
